export enum EModelApiPaths {
    API = '/api',
    CUSTOM_API_BASE = '/custom-api',
    SYSTEM_API_BASE = '/system-api',
    THIRD_PARTY_API_BASE = '/third-party',

    USER_LOGIN = '/gudiya_printing/gudiya-printing-login',
    FILE_UPLOAD_ORDER = '/gudiya_printing/upload-file?uploadToPath=/order_files',
    FILE_UPLOAD = '/gudiya_printing/upload-file?uploadToPath=/payment_receipts',
    ORDER_PLACE_EMAIL_OR_NOTIFICATION = '/gudiya_printing/order-Place/email-or-notification',
    CONTACT_MAIL_SEND = '/gudiya_printing/contact-mail-send',
    FORGOT_PASSWORD = '/gudiya_printing/forgot-password',
    NEW_USER_REGISTRATION = '/gudiya_printing/new-user-registration',
}
